<script>
   /**************************************************************/
   /* Svelte component for ScoresPlot settings                   */
   /**************************************************************/

   import Container from '../controls/Container.svelte';
   import Select from '../controls/Select.svelte';
   import Range from '../controls/Range.svelte';
   import PlotTypeSelector from '../controls/PlotTypeSelector.svelte';

   export let params;
   export let res;

   let comp1 = 1;
   let comp2 = res && res.ncomp > 1 ? 2 : 1;
   let plotType = 'p';
   let colorBy = 'none';
   let colorByVar = 1;
   let showLabels = 'hide';
   let showEllipse = 'hide';
   let confEllipse = 'none';

   $: colorByOptions = res.classNames && res.classNames.length > 1 ? ['none', 'groups', 'variable'] : ['none', 'variable'];

   $: params = {
      comp: [comp1, comp2],
      plotType,
      showLabels,
      colorBy,
      colorByVar,
      showEllipse,
      confEllipse
   }

   $: if (plotType !== 'p' || (colorBy === 'groups' && confEllipse !== 'none')) showEllipse = 'hide';
   $: if (plotType !== 'p' || colorBy !== 'groups') confEllipse = 'none';
</script>

{#if res }
<Container label="">
   <p class="title">Scores plot</p>
</Container>
<PlotTypeSelector bind:value={plotType} plotTypeOptions={['p', 'l', 'h']} />

<Container label='PC (y-axis):'>
   <Range id='comp2' bind:value={comp2} min={1} max={res.ncomp} step={1} decNum={0} discrete={true}  />
</Container>
{#if plotType === 'p'}
<Container label='PC (x-axis):'>
   <Range id='comp1' bind:value={comp1} min={1} max={res.ncomp} step={1} decNum={0} discrete={true} />
</Container>
{/if}
<Container label='Labels:'>
   <Select id='showLabels' bind:value={showLabels} options={['hide', 'show']} />
</Container>

{#if plotType === 'p'}
<Container label='T2 ellipse:'>
   <Select id='showEllipse' bind:value={showEllipse} options={['hide', 'show']} />
</Container>
{/if}

{#if plotType !== 'l'}
<Container label='Color by:'>
   <Select id='colorBy' bind:value={colorBy} options={colorByOptions} />
</Container>
{#if colorBy === 'variable'}
<Container label='Variable:'>
   <Range id='colorByVar' bind:value={colorByVar} min={1} max={res.ncols} step={1} decNum={0} discrete={true} />
</Container>
{/if}
{/if}

{#if plotType === 'p' && colorBy === 'groups'}
<Container label='Conf ellipse:'>
   <Select id='confEllipse' bind:value={confEllipse} options={['none', '90', '95', '99']} />
</Container>
{/if}

{/if}
